const getPagesToCreate = (initialPages, currentPages) => {
  const initialPageIdsSet = new Set(initialPages.map((p) => p.id));
  return currentPages.filter((page) => !initialPageIdsSet.has(page.id));
};

export default getPagesToCreate;
